// Testids for the in-SPA auth flow: LoginPage, PendingApprovalPage. The
// actual Keycloak login/signup forms are hosted outside this codebase and
// cannot receive data-testid attrs from here.

export const loginTestIds = {
  // Page container (redirect shim)
  page: 'login-page',
  container: 'login-container',
  logo: 'login-logo',

  // Redirecting state (normal)
  redirectingTitle: 'login-redirecting-title',
  redirectingSubtitle: 'login-redirecting-subtitle',
  spinner: 'login-spinner',

  // Error state (Keycloak unreachable)
  errorTitle: 'login-error-title',
  errorSubtitle: 'login-error-subtitle',
  retryButton: 'login-retry-button',
} as const;

export const pendingApprovalTestIds = {
  page: 'pending-approval-page',
  card: 'pending-approval-card',
  heading: 'pending-approval-heading',
  message: 'pending-approval-message',
  hint: 'pending-approval-hint',
  signOutButton: 'pending-approval-sign-out-button',
} as const;

export const accessExpiredTestIds = {
  page: 'access-expired-page',
  card: 'access-expired-card',
  heading: 'access-expired-heading',
  message: 'access-expired-message',
  hint: 'access-expired-hint',
  retryButton: 'access-expired-retry-button',
  signOutButton: 'access-expired-sign-out-button',
} as const;

export const blockedTestIds = {
  page: 'blocked-page',
  card: 'blocked-page-card',
  title: 'blocked-page-title',
  message: 'blocked-page-message',
  contact: 'blocked-page-contact',
  countdown: 'blocked-page-countdown',
  signOutButton: 'blocked-page-sign-out-button',
} as const;

// EntitlementGate's "we could not find out" state — a failed entitlements read,
// distinct from an org that genuinely does not hold the feature (which
// redirects). Same family as the gates above: a full-page shim, not a page.
export const entitlementGateTestIds = {
  unavailable: 'entitlement-unavailable-page',
  unavailableHeading: 'entitlement-unavailable-heading',
  unavailableMessage: 'entitlement-unavailable-message',
  unavailableRetryButton: 'entitlement-unavailable-retry-button',
} as const;

// The pre-auth shell. AuthGate blocks on Keycloak init plus the memberships
// read, and this is what fills that wait -- see components/AppShellSkeleton.tsx.
export const appShellTestIds = {
  loadingSkeleton: 'app-shell-loading-skeleton',
} as const;

// Terminal screen for a session that resolved no organisation — a
// competitor-domain signup (deliberately given no workspace), an account whose
// provisioning never completed, or a memberships read that failed outright.
export const noWorkspaceTestIds = {
  page: 'no-workspace-page',
  card: 'no-workspace-card',
  heading: 'no-workspace-heading',
  message: 'no-workspace-message',
  detail: 'no-workspace-detail',
  retryButton: 'no-workspace-retry-button',
  supportLink: 'no-workspace-support-link',
  signOutButton: 'no-workspace-sign-out-button',
} as const;
